import { render, staticRenderFns } from "./BudgetsList.vue?vue&type=template&id=5c0cb05b&scoped=true"
import script from "./BudgetsList.vue?vue&type=script&lang=js"
export * from "./BudgetsList.vue?vue&type=script&lang=js"
import style0 from "./BudgetsList.vue?vue&type=style&index=0&id=5c0cb05b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0cb05b",
  null
  
)

export default component.exports